// extracted by mini-css-extract-plugin
export var heroImage = "_k6-1";
export var modal = "_k6-0";